import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useCommerceDebutGuideStore } from "@/stores/commerceDebutGuide";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommerceDebutGuideSideMenu',
  setup(__props) {

const commerceDebutGuideStore = useCommerceDebutGuideStore();

// 選択されたメニューを管理
const selectedMenu = ref<string>("menu1");

// メニューを選択する関数
const selectMenu = (menu: string) => {
  selectedMenu.value = menu;
  commerceDebutGuideStore.setSelectedMenu(menu);
};

return { __sfc: true,commerceDebutGuideStore, selectedMenu, selectMenu }
}

})